import { render, staticRenderFns } from "./release-reserve.vue?vue&type=template&id=9f2f8dce&scoped=true&lang=pug"
import script from "./release-reserve.vue?vue&type=script&lang=js"
export * from "./release-reserve.vue?vue&type=script&lang=js"
import style0 from "./release-reserve.vue?vue&type=style&index=0&id=9f2f8dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2f8dce",
  null
  
)

export default component.exports